<div class="mainContainer">
    <div class="filter_show" *ngIf="!showTotalSummary">
        <div class="mi-header">
            <div class="mi-header__main">
                <h2 class="log_track">Mess Daysheet Details</h2>
                <div class="mi-header-fields">
                    <div class="mi-stock-date">
                        <div class="mi-building-name">
                            <p class="stock_title">Kitchen Name :</p>
                            <input type="text" class="form-control mi-building-name__input"
                                [(ngModel)]="userbuildingName" name="userbuildingName" readonly />
                        </div>
                        <p class="stock_title">Date :</p>
                        <div class="mi-stock-date__field">
                            <input matInput [matDatepicker]="mydate" [matDatepickerFilter]="messInventoryDateFilter"
                                (click)="mydate.open()" [(ngModel)]="stockPickerDate" name="stockPickerDate"
                                (dateChange)="onStockDateChange($event)" class="form-control form-date"
                                placeholder="Date" />
                            <mat-datepicker-toggle matSuffix [for]="mydate" class="datepic">
                            </mat-datepicker-toggle>
                        </div>
                        <mat-datepicker #mydate [dateClass]="daysheetDateClass" panelClass="mi-daysheet-datepicker"
                            (opened)="onDaysheetDatepickerOpened()">
                        </mat-datepicker>
                        <div class="mi-datepicker-status-source" aria-hidden="true">
                            <div class="status_flex mi-datepicker-status">
                                <div class="status_item">
                                    <span class="holiday"></span>
                                    <p>Holiday</p>
                                </div>
                                <div class="status_item">
                                    <span class="closed"></span>
                                    <p>Closed</p>
                                </div>
                                <div class="status_item">
                                    <span class="pending"></span>
                                    <p>Pending</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <button type="button" class="add_item_btn" [disabled]="isAddHolidayDisabled()"
                (click)="toggleHolidayCard()">
                <mat-icon class="mi-add-holiday-btn__icon">add</mat-icon>
                <span>Add holiday</span>
            </button>
        </div>
    </div>
    <div class="mess-box" *ngIf="!showTotalSummary">
        <!-- <div class="status_flex">
            <div class="status_item">
                <span class="holiday"></span>
                <p>Holiday</p>
            </div>

            <div class="status_item">
                <span class="closed"></span>
                <p>Closed</p>
            </div>

            <div class="status_item">
                <span class="pending"></span>
                <p>Pending</p>
            </div>
        </div> -->
       
        <div class="icon_flex">
            <!-- <div class="status_flex">
                <div class="status_item">
                    <span class="holiday"></span>
                    <p>Holiday</p>
                </div>
    
                <div class="status_item">
                    <span class="closed"></span>
                    <p>Closed</p>
                </div>
    
                <div class="status_item">
                    <span class="pending"></span>
                    <p>Pending</p>
                </div>
            </div> -->
            <p class="search_title">Search :</p>
            <input type="text" name="" id="" placeholder="Search" (input)="onfilterChange($event)"
                class="form-control search_input">
            <p class="lang_title">Language :</p>
            <select name="itemNameLang" class="form-control item-name-lang" [(ngModel)]="itemNameDisplayLang"
                (ngModelChange)="onItemNameLangChange()">
                <option value="en">English</option>
                <option value="te">Telugu</option>
            </select>
            <div class="icon_flex__actions">
                <button type="button" class="add_item_btn" (click)="MenuCard()" [disabled]="isHolidayBlockingActions()">
                    <mat-icon class="mi-add-holiday-btn__icon">add</mat-icon>
                    Menu card
                </button>
                <button type="button" class="add_item_btn" (click)="openMessSummaryDialog()"
                    [disabled]="isHolidayBlockingActions()">
                    <mat-icon class="mi-add-holiday-btn__icon">add</mat-icon>
                    Supply Building
                </button>
            </div>
            <!-- <button type="button" class="add_item_btn" (click)="addItem()"
                [disabled]="isDaysheetSubmitDisabled || isHolidayBlockingActions() || !isRegularItemsAllowed()">
                <mat-icon class="mi-add-holiday-btn__icon">add</mat-icon>
                Add Item
            </button> -->
        </div>

        <div class="mi-menu-list" *ngIf="messBoxMenuList.length">
            <div class="mi-menu-list__title">Today's Menu</div>
            <div class="mi-menu-list__row" *ngFor="let menu of messBoxMenuList">
                <span class="mi-menu-list__scenario">{{ menu.scenarioName }}:</span>
                <span class="mi-menu-list__items">{{ menu.menuItems }}</span>
            </div>
        </div>

        <!-- MESS-INVENTORY-TABLE --->

        <div class="content" style="width: 100%; height: 50%;">
            <ag-grid-angular style="width: 100%; height: 500px;" [rowData]="rowData"
                [pinnedBottomRowData]="pinnedBottomRowData" [columnDefs]="colDefs" [defaultColDef]="defaultColDef"
                (cellValueChanged)="onCellValueChanged($event)" (gridReady)="onGridReady($event)"
                [suppressRowClickSelection]="true" [rowSelection]="'multiple'" [suppressCellFocus]="false"
                [suppressHeaderFocus]="true" [rowHeight]="40" [quickFilterText]="quickFilter"
                [overlayLoadingTemplate]="overlayLoadingTemplate" [overlayNoRowsTemplate]="overlayNoRowsTemplate" />
        </div>
        <!-- 
        <div class="table-total-amount">
            <div class="table-total-amount__label">Total Amount</div>
            
        </div> -->

        <div class="submit">
            <button type="button" class="sbd__btn" (click)="submit()" [disabled]="isHolidayBlockingActions()">Total
                Summary
            </button>
        </div>
    </div>

    <div class="total-summary-panel" *ngIf="showTotalSummary && totalSummaryData">
        <div class="total-summary-panel__header">
            <button type="button" class="total-summary-panel__back" (click)="closeTotalSummary()" aria-label="Back">
                <mat-icon>arrow_back</mat-icon>
                <span>Back</span>
            </button>
            <h3 class="total-summary-panel__title">Daysheet Total Summary</h3>
            <!-- <span class="total-summary-panel__status" *ngIf="totalSummaryData.status">
                {{ totalSummaryData.status }}
            </span> -->
        </div>

        <div class="total-summary-panel__meta">
            <!-- <span *ngIf="totalSummaryData.daysheetId">Daysheet ID: {{ totalSummaryData.daysheetId }}</span> -->
            <span><strong class="total-summary-panel__meta-label">Day Sheet Date:</strong> {{ selectDate }}</span>
            <span><strong class="total-summary-panel__meta-label">Students:</strong> {{
                totalSummaryData.studentCount }}</span>
            <span><strong class="total-summary-panel__meta-label">Employees:</strong> {{
                totalSummaryData.employeeCount }}</span>
            <span><strong class="total-summary-panel__meta-label">Sub Staff:</strong> {{
                totalSummaryData.subStaffCount }}</span>
            <span><strong class="total-summary-panel__meta-label">Others:</strong> {{ totalSummaryData.visitorsCount
                }}</span>
            <span><strong class="total-summary-panel__meta-label">Total Cost(₹):</strong> {{
                inrGroupedNumber(totalSummaryData.daysheetAmount) }}</span>
            <span *ngIf="totalSummaryPerHeadPrice > 0">
                <strong class="total-summary-panel__meta-label">Per Head(₹):</strong>{{
                inrGroupedNumber(totalSummaryPerHeadPrice) }}
            </span>
            <div class="total-summary-panel__view-toggle">
                <button type="button" class="total-summary-panel__view-toggle-btn"
                    [class.total-summary-panel__view-toggle-btn--active]="summaryViewMode === 'all'"
                    (click)="setSummaryViewMode('all')">All</button>
                <button type="button" class="total-summary-panel__view-toggle-btn"
                    [class.total-summary-panel__view-toggle-btn--active]="summaryViewMode === 'summary'"
                    (click)="setSummaryViewMode('summary')">Summary</button>
            </div>
        </div>

        <div class="total-summary-panel__all-view" *ngIf="summaryViewMode === 'all'">
            <div class="total-summary-panel__todays-menu">
                <div class="total-summary-panel__todays-menu-title">Today's Menu</div>
                <div class="total-summary-panel__todays-menu-row" *ngFor="let menu of getTodaysMenuList()">
                    <span class="total-summary-panel__todays-menu-scenario">{{ menu.scenarioName }}:</span>
                    <span class="total-summary-panel__todays-menu-items">{{ menu.menuItems }} .</span>
                </div>
            </div>

            <div class="total-summary-panel__scenario-box">
                <div class="total-summary-panel__table-wrap">
                    <div class="total-summary-panel__table">
                        <div class="total-summary-panel__thead">
                            <div class="nums__item">Item</div>
                            <div class="num">Rate(₹)</div>
                            <div class="num">Breakfast Qty</div>
                            <div class="num">Lunch Qty </div>
                            <div class="num">Snacks Qty</div>
                            <div class="num">Dinner Qty</div>
                            <div class="num">Total Qty</div>
                            <div class="num">Open Qty</div>
                            <div class="num">Closed Qty</div>
                            <div class="num">Total Cost(₹)</div>
                        </div>
                        <div class="total-summary-panel__tbody">
                            <div class="total-summary-panel__tr" *ngFor="let item of allSummaryRows">
                                <div class="total-summary-panel__item-name">{{ item.itemName }}</div>
                                <div class="num">{{ inrGroupedNumber(item.ratePerUnit) }}</div>
                                <div class="num">{{ item.bfQty }}</div>
                                <div class="num">{{ item.lunchQty }}</div>
                                <div class="num">{{ item.snacksQty }}</div>
                                <div class="num">{{ item.dinnerQty }}</div>
                                <div class="num">{{ item.totalQty }}</div>
                                <div class="num">{{ inrGroupedNumber(item.onHandQty) }}</div>
                                <div class="num">{{ inrGroupedNumber(getSummaryClosedQty(item)) }}</div>
                                <div class="num">{{ inrGroupedNumber(item.totalCost) }}</div>
                            </div>
                            <div class="total-summary-panel__tr total-summary-panel__tr--empty"
                                *ngIf="!allSummaryRows.length">
                                <div class="total-summary-panel__empty-cell">No inventory items</div>
                            </div>
                        </div>
                        <div class="total-summary-panel__scenario-total">
                            <span>Total Cost</span>
                            <span class="total-summary-panel__scenario-total-value">
                                ₹{{ inrGroupedNumber(allSummaryTotalCost) }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="total-summary-panel__scenarios" *ngIf="summaryViewMode === 'summary'">
            <div class="total-summary-panel__scenario-box"
                *ngFor="let scenario of totalSummaryData.scenarioBasedMenuItemsList">
                <button type="button" class="total-summary-panel__scenario-title"
                    (click)="toggleSummaryScenarioExpand(scenario)"
                    [attr.aria-expanded]="isSummaryScenarioExpanded(scenario)">
                    <span class="total-summary-panel__scenario-title-text">
                        <span>{{ scenario.scenarioName }}</span>
                        <span class="total-summary-panel__scenario-menu-count">
                            ({{ getSummaryMenuItemCount(scenario) }})
                        </span>
                    </span>
                    <mat-icon class="total-summary-panel__scenario-chevron">
                        {{ isSummaryScenarioExpanded(scenario) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                    </mat-icon>
                </button>
                <div class="total-summary-panel__scenario-menu">
                    <span class="total-summary-panel__scenario-menu-label">Menu Items:</span>
                    {{ getSummaryMenuLabel(scenario) }}
                </div>

                <div class="total-summary-panel__table-wrap" *ngIf="isSummaryScenarioExpanded(scenario)">
                    <div class="total-summary-panel__table total-summary-panel__table--scenario">
                        <div class="total-summary-panel__thead">
                            <div class="nums__item">Item</div>
                            <div class="num">Rate(₹)</div>
                            <div class="num">{{ getScenarioMealQtyLabel(scenario) }}</div>
                            <div class="num">Total Qty</div>
                            <div class="num">Open Qty</div>
                            <div class="num">Closed Qty</div>
                            <div class="num">Total Cost(₹) </div>
                        </div>
                        <div class="total-summary-panel__tbody">
                            <div class="total-summary-panel__tr"
                                *ngFor="let item of scenario.saveInventoryBalanceDetails">
                                <div class="total-summary-panel__item-name">{{ item.itemName }}</div>
                                <div class="num">{{ inrGroupedNumber(item.ratePerUnit) }}</div>
                                <div class="num">{{ getScenarioMealQtyValue(scenario, item) }}</div>
                                <div class="num">{{ item.totalQty }}</div>
                                <div class="num">{{ inrGroupedNumber(item.onHandQty) }}</div>
                                <div class="num">{{ inrGroupedNumber(getSummaryClosedQty(item)) }}</div>
                                <div class="num">{{ inrGroupedNumber(item.totalCost) }}</div>
                            </div>
                            <div class="total-summary-panel__tr total-summary-panel__tr--empty"
                                *ngIf="!scenario.saveInventoryBalanceDetails?.length">
                                <div class="total-summary-panel__empty-cell">No inventory items</div>
                            </div>
                        </div>
                        <div class="total-summary-panel__scenario-total">
                            <span>Total Cost</span>
                            <span class="total-summary-panel__scenario-total-value">
                                ₹{{ inrGroupedNumber(getScenarioSummaryTotalCost(scenario)) }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="total-summary-panel__footer">
            <button type="button" class="sbd__btn sbd__btn--ghost" (click)="closeTotalSummary()">Back</button>
            <button type="button" class="sbd__btn" (click)="confirmDaysheetSubmit()"
                [disabled]="isDaysheetSubmitDisabled || isHolidayBlockingActions()">Daysheet Submit</button>
        </div>
    </div>
</div>

<!-- ================================ loader ======================-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>